var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEventEntry = function SvgEventEntry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 8a1 1 0 0 1 .441 1.896c2.744 3.638 8.373 3.638 11.117 0A.999.999 0 0 1 18 8h2a1 1 0 0 1 .102 1.995L20 10v10h1a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h1v-7.64c-3.364 3.018-8.636 3.018-12 0V20h1a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h1V10l-.103-.005A1 1 0 0 1 4 8zM5 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4m14 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
  })));
};
export default SvgEventEntry;